import React from 'react';

const ItemsTab = React.lazy(() => import('../tabs/ItemsTab'));
const KitsTab = React.lazy(() => import('../tabs/KitsTab'));
const VendorsTab = React.lazy(() => import('../tabs/VendorsTab'));
const BomsTab = React.lazy(() => import('../tabs/BomsTab'));
const PurchaseRequisitionsTab = React.lazy(() => import('../tabs/PurchaseRequisitionsTab'));
const PurchaseOrdersTab = React.lazy(() => import('../tabs/PurchaseOrdersTab'));
const InventoryTab = React.lazy(() => import('../tabs/InventoryTab'));
const InventoryPullsTab = React.lazy(() => import('../tabs/InventoryPullsTab'));

export type TabConfig = {
  id: string;
  label: string;
  path: string;
  legacy?: string;
  persist?: boolean;
  Component: React.LazyExoticComponent<React.ComponentType>;
};

export const TAB_CONFIG: TabConfig[] = [
  { id: 'items', label: 'Items', path: 'items', Component: ItemsTab },
  { id: 'kits', label: 'Kits', path: 'kits', Component: KitsTab },
  { id: 'vendors', label: 'Vendors', path: 'vendors', Component: VendorsTab },
  { id: 'boms', label: 'BOMs', path: 'boms', Component: BomsTab },
  {
    id: 'prs',
    label: 'Purchase Requisitions',
    path: 'purchase-requisitions',
    legacy: 'prs',
    persist: true,
    Component: PurchaseRequisitionsTab,
  },
  {
    id: 'pos',
    label: 'Purchase Orders',
    path: 'purchase-orders',
    legacy: 'pos',
    persist: true,
    Component: PurchaseOrdersTab,
  },
  { id: 'inventory', label: 'Inventory', path: 'inventory', Component: InventoryTab },
  {
    id: 'inventory_pulls',
    label: 'Inventory Pulls',
    path: 'inventory-pulls',
    legacy: 'inventory_pulls',
    Component: InventoryPullsTab,
  },
];

export const DEFAULT_TAB = TAB_CONFIG[0];
